// Real screenshots of teacher testimonials (DMs/comments/emails), used as-is —
// the images already contain the review text, so no captions are overlaid.
export const testimonialImages: string[] = [
  'https://cdn.magicpatterns.com/uploads/2YSnPtWXAmfe6TnDmmRkeM/Imagen_de_ChatGPT_27_sept_2026,_13_33_11.webp',
  'https://cdn.magicpatterns.com/uploads/cuYrgfE56FNZuRYCKWm5aM/Imagen_de_ChatGPT_27_sept_2026,_13_33_14.webp',
  'https://cdn.magicpatterns.com/uploads/m5hp5exQf5NS6KMXGJnAem/Imagen_de_ChatGPT_27_sept_2026,_13_33_06.webp',
  'https://cdn.magicpatterns.com/uploads/3y2Nyn3acRPfUJtz3X3FMb/Imagen_de_ChatGPT_27_sept_2026,_13_33_03.webp',
  'https://cdn.magicpatterns.com/uploads/pSXxDnhj9WerPN7BzEEy5e/Imagen_de_ChatGPT_27_sept_2026,_13_33_19.png'
];
